import { useContext, useDebugValue } from 'react';

import AuthContext from '@frolight/context/AuthProvider';

const useAuth = () => {
  const { auth } = useContext(AuthContext);
  useDebugValue(auth, auth => auth?.accessToken ? 'Is signed in' : 'Not signed in');
  return useContext(AuthContext);
};

export default useAuth;
